var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.42,
    height: 20.989,
    viewBox: "0 0 14.42 20.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Water_4365945_1_",
    "data-name": "noun_Water_4365945 (1)",
    transform: "translate(-15.73 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8",
    transform: "translate(15.88 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M22.416,3.7a.455.455,0,0,0-.072-.25.432.432,0,0,0-.362-.194c-.207,0-.364,0-1.384,1.448-.621.89-1.32,1.978-1.955,3.06-1.26,2.15-2.762,5.063-2.762,6.8a6.122,6.122,0,0,0,12.244,0c0-1.645-1.332-3.366-2.741-5.187C23.924,7.5,22.416,5.547,22.416,3.7ZM22,19.861a5.3,5.3,0,0,1-5.294-5.294c0-2.375,3.563-8.081,4.965-9.957.37,1.8,1.732,3.567,3.056,5.278S27.3,13.2,27.3,14.567A5.3,5.3,0,0,1,22,19.861Zm.244-2.346a.414.414,0,0,1-.414.414,3.484,3.484,0,0,1-3.48-3.48.414.414,0,1,1,.828,0A2.654,2.654,0,0,0,21.832,17.1.414.414,0,0,1,22.246,17.515ZM28.827,2.6A4.325,4.325,0,0,1,27.668.426a.424.424,0,0,0-.126-.3.414.414,0,0,0-.3-.128c-.159,0-.414,0-1.576,1.963a7.457,7.457,0,0,0-1.163,2.9A2.747,2.747,0,0,0,30,4.86,4.2,4.2,0,0,0,28.827,2.6ZM27.255,6.782a1.92,1.92,0,0,1-1.92-1.918,10.406,10.406,0,0,1,1.7-3.517A8.09,8.09,0,0,0,28.173,3.1a3.928,3.928,0,0,1,1,1.761A1.92,1.92,0,0,1,27.255,6.782Zm.693-.9a.414.414,0,0,1-.414.414,1.668,1.668,0,0,1-1.655-1.655.414.414,0,1,1,.828,0,.828.828,0,0,0,.828.838.414.414,0,0,1,.414.4Z",
    transform: "translate(-15.88 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/water_drop.12c122651d092f7f2c332fade251f7df.svg";
export { ForwardRef as ReactComponent };